import type { InvoiceRow } from "@/types/api";

/** Client-side filter on current page — invoice id or number (partial match). */
export function filterInvoicesByQuery(
  items: InvoiceRow[],
  query: string,
): InvoiceRow[] {
  const needle = query.trim().toLowerCase();
  if (!needle) return items;
  return items.filter(
    (row) =>
      row.id.toLowerCase().includes(needle) ||
      (row.invoice_number ?? "").toLowerCase().includes(needle),
  );
}
